import { render, staticRenderFns } from "./AccountControl.vue?vue&type=template&id=288b9764&scoped=true"
import script from "./AccountControl.vue?vue&type=script&lang=js"
export * from "./AccountControl.vue?vue&type=script&lang=js"
import style0 from "./AccountControl.vue?vue&type=style&index=0&id=288b9764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b9764",
  null
  
)

export default component.exports